import React from 'react';
import { AiOutlineReload as ReloadIcon } from 'react-icons/ai';

const Page404Component = () => {
  const reloadHandler = () => {
    window.location.href = 'https://fenyx.smartcompanion.fr';
  };
  return (
    <div id="smart-apps-page">
      <h1>Not Found</h1>
      <button type="button" onClick={reloadHandler}>
        <ReloadIcon />
      </button>
    </div>
  );
};

export default Page404Component;
